import { useEffect, useRef, useState } from "react";
import { useFormikContext } from "formik";
import { useDebounce } from "react-use";
import { isEqual } from "lodash";

export const FormAutoSubmitter = () => {
  const { values, submitForm, setSubmitting } = useFormikContext();
  const [valuesToSubmit, setValuesToSubmit] = useState(null);

  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && !isEqual(ref.current, values)) {
      setSubmitting(true);
      setValuesToSubmit(values);
    }
    ref.current = values;
  }, [values]);

  useDebounce(() => valuesToSubmit && submitForm(valuesToSubmit), 500, [
    valuesToSubmit,
  ]);

  return null;
};
